/* eslint-disable no-unused-vars */
export enum APPLICATION_STATES_ENUM {
  IN_PROGRESS = 'IN_PROGRESS',
  APPLICATION_SUBMITTED = 'SUBMITTED',
  LEASE_SENT = 'LEASE_SENT',
  LEASE_UPLOADED = 'LEASE_UPLOADED',
  LEASE_SIGNED_APPLICANTS = 'LEASE_SIGNED_APPLICANTS',
  LEASE_SIGNED_LANDLORD = 'LEASE_SIGNED_LANDLORD',
  PAYMENTS_REQUESTED = 'PAYMENTS_REQUESTED',
  PAYMENTS_RECEIVED = 'PAYMENTS_RECEIVED',
  ACCEPTED = 'FINALIZED',
  CANCELLED = 'CANCELLED',
  DENIED = 'DENIED',
  UNAVAILABLE = 'UNAVAILABLE',
  IN_PROGRESS_UNAVAILABLE = 'IN_PROGRESS_UNAVAILABLE',
  REQUESTED = 'REQUESTED',
  INVITED = 'INVITED',
}

export enum CREDIT_CHECK_STATES_ENUM {
  PENDING = 'PENDING',
  IN_PROGRESS = 'IN_PROGRESS',
  DONE = 'DONE',
  FAILED = 'FAILED',
}

export enum TRANSUNION_STATES_ENUM {
  UNVERIFIED = 'UNVERIFIED',
  MANUAL_AUTHENTICATION = 'MANUAL_AUTHENTICATION',
  VERIFIED = 'VERIFIED',
}

// @typescript-eslint/no-duplicate-enum-values
export enum APPLICATION_STATES_LABELS_ENUM {
  IN_PROGRESS = 'In Progress',
  APPLICATION_IN_PROGRESS = 'Application In Progress',
  APPLICATION_SUBMITTED = 'Application Submitted',
  SEND_LEASE = 'Send Lease',
  LEASE_SENT = 'Lease Sent',
  AWAITING_SIGNATURE = 'Awaiting Signature',
  AWAITING_SIGNATURE_LANDLORD = 'Awaiting Landlord Signature',
  AWAITING_SIGNATURE_APPLICANTS = 'Awaiting Applicants Signature',
  LANDLORD_SIGNATURE = 'Landlord Signature',
  LEASE_SIGNED = 'Lease Signed',
  APPLICANTS_SIGNED = 'Applicants Signed',
  LANDLORD_SIGNED = 'Landlord Signed',
  REQUEST_PAYMENT = 'Request Payment',
  PAYMENT_REQUESTED = 'Payment Requested',
  AWAITING_PAYMENT = 'Awaiting Payment',
  PAYMENTS_RECEIVED = '#PAYMENT# Received',
  APPLICATION_ACCEPTED = 'Close Deal',
  VERIFYING_APPLICATION = 'Reviewing Application',
  APPLICATION_VERIFIED = 'Application Verified',
  SIGN_LEASE = 'Sign Lease',
  VERIFYING_LEASE = 'Verifying Lease',
  LEASE_VERIFIED = 'Lease Verified',
  MAKE_PAYMENT = 'Make Payment',
  PAYMENT_PAID = '#PAYMENT# Paid',
  APPLICATION_APPROVAL = 'Move In!',
  CANCELLED = 'Application Cancelled',
  DENIED = 'Application Denied',
  UNAVAILABLE = 'Application Unavailable',
  MOVE_IN = 'Move In',
  INVITE_REJECTED = 'Invite Rejected',
  SUBMITTED_AND_FINALIZED = 'Submitted and Finalized',
}

export enum APPLICATION_CO_APPLICANT_ENUM {
  INVITED = 'INVITED',
  IN_PROGRESS = 'ACCEPTED_AND_IN_PROGRESS',
  COMPLETED = 'COMPLETED',
  SIGNED_WITHOUT_WEBHOOK = 'SIGNED_WITHOUT_WEBHOOK',
  SIGNED = 'SIGNED',
  REJECTED = 'REJECTED',
}

/**
 * Application states const from agent side.
 */
const AGENT_APPLICATION_INITIAL_STATES = [
  {
    label: APPLICATION_STATES_LABELS_ENUM.APPLICATION_SUBMITTED,
    value: APPLICATION_STATES_ENUM.APPLICATION_SUBMITTED,
    isDisabledBtn: false,
    isCompleted: false,
    buttonText: '',
  },
  {
    label: APPLICATION_STATES_LABELS_ENUM.SEND_LEASE,
    value: APPLICATION_STATES_ENUM.LEASE_SENT,
    isDisabledBtn: true,
    isCompleted: false,
    buttonText: 'Upload',
  },
  {
    label: APPLICATION_STATES_LABELS_ENUM.AWAITING_SIGNATURE,
    value: APPLICATION_STATES_ENUM.LEASE_SIGNED_APPLICANTS,
    isDisabledBtn: false,
    isCompleted: false,
    buttonText: '',
  },
  {
    label: APPLICATION_STATES_LABELS_ENUM.APPLICATION_ACCEPTED,
    value: APPLICATION_STATES_ENUM.ACCEPTED,
    isDisabledBtn: false,
    isCompleted: false,
    buttonText: 'Close!',
  },
];

/**
 * Application states const from agent side.
 */
const AGENT_WITH_LANDLORD_APPLICATION_INITIAL_STATES = [
  {
    label: APPLICATION_STATES_LABELS_ENUM.APPLICATION_SUBMITTED,
    value: APPLICATION_STATES_ENUM.APPLICATION_SUBMITTED,
    isDisabledBtn: false,
    isCompleted: false,
    buttonText: '',
  },
  {
    label: APPLICATION_STATES_LABELS_ENUM.SEND_LEASE,
    value: APPLICATION_STATES_ENUM.LEASE_SENT,
    isDisabledBtn: false,
    isCompleted: false,
    buttonText: 'Upload',
  },
  {
    label: APPLICATION_STATES_LABELS_ENUM.AWAITING_SIGNATURE_APPLICANTS,
    value: APPLICATION_STATES_ENUM.LEASE_SIGNED_APPLICANTS,
    isDisabledBtn: false,
    isCompleted: false,
    buttonText: '',
  },

  {
    label: APPLICATION_STATES_LABELS_ENUM.LANDLORD_SIGNATURE,
    value: APPLICATION_STATES_ENUM.LEASE_SIGNED_LANDLORD,
    isDisabledBtn: false,
    isCompleted: false,
    buttonText: '',
  },
  {
    label: APPLICATION_STATES_LABELS_ENUM.APPLICATION_ACCEPTED,
    value: APPLICATION_STATES_ENUM.ACCEPTED,
    isDisabledBtn: false,
    isCompleted: false,
    buttonText: 'Close!',
  },
];

const RENTER_APPLICATION_INITIAL_STATES = [
  {
    label: APPLICATION_STATES_LABELS_ENUM.APPLICATION_IN_PROGRESS,
    value: APPLICATION_STATES_ENUM.IN_PROGRESS,
    isDisabledBtn: false,
    isCompleted: false,
    buttonText: '',
  },
  {
    label: APPLICATION_STATES_LABELS_ENUM.APPLICATION_SUBMITTED,
    value: APPLICATION_STATES_ENUM.APPLICATION_SUBMITTED,
    isCompleted: false,
    buttonText: 'Continue',
  },
  {
    label: APPLICATION_STATES_LABELS_ENUM.VERIFYING_APPLICATION,
    value: APPLICATION_STATES_ENUM.LEASE_SENT,
    isDisabledBtn: false,
    isCompleted: false,
    buttonText: 'Modify',
  },
  {
    label: APPLICATION_STATES_LABELS_ENUM.SIGN_LEASE,
    value: APPLICATION_STATES_ENUM.LEASE_SIGNED_APPLICANTS,
    isDisabledBtn: true,
    isCompleted: false,
    buttonText: 'Sign',
  },
  {
    label: APPLICATION_STATES_LABELS_ENUM.APPLICATION_APPROVAL,
    value: APPLICATION_STATES_ENUM.ACCEPTED,
    isDisabledBtn: false,
    isCompleted: false,
    buttonText: '',
  },
];

// Map tab IDs to API status values
// Submitted tab includes all post-submission statuses
// In Progress tab includes applications that are still being worked on
const AGENT_MY_APPLICATION_TABS_STATUS_MAP: Record<string, string> = {
  requested: 'requested',
  submitted:
    'submitted,lease_sent,lease_uploaded,lease_signed_applicants,lease_signed_landlord,payments_received,finalized,cancelled,denied,unavailable',
  inprogress: 'in_progress,in_progress_unavailable',
};

export enum AGENT_MY_APPLICATION_TABS {
  REQUESTED = 'requested',
  SUBMITTED = 'submitted',
  IN_PROGRESS = 'inprogress',
}

export const CREDIT_SCORE_DISPLAY_VALUES = {
  WAIVED: 'Waived',
  NO_DATA_YET: 'No Data Yet',
  N_A: 'N/A',
};

export const DROP_CATEGORY = {
  CATEGORY: 'droppable-category',
  SUB_CATEGORY: 'droppable-sub-category',
};

export const SPECIAL_OPTIONS = {
  SOMEONE_NOT_ON_ZEME: 'someone-not-on-zeme',
  NO_LONGER_AVAILABLE: 'no-longer-available',
};

export const APPLICATION_SORT_ORDER =
  'REQUESTED,SUBMITTED,LEASE_UPLOADED,LEASE_SENT,LEASE_SIGNED_APPLICANTS,LEASE_SIGNED_LANDLORD,FINALIZED,DENIED,CANCELLED,UNAVAILABLE,IN_PROGRESS_UNAVAILABLE,IN_PROGRESS';

export enum StatusVariant {
  GRAY = 'gray',
  SUCCESS = 'success',
  IN_PROGRESS = 'inprogress',
  ERROR = 'error',
}

export enum StatusText {
  REQUESTED = 'Requested',
  SUBMITTED = 'Submitted',
  IN_PROGRESS = 'In Progress',
}

export enum ApplicantVariant {
  IN_PROGRESS = 'inprogress',
  SUCCESS = 'success',
  ERROR = 'error',
  GRAY = 'gray',
}

export enum ApplicantText {
  IN_PROGRESS = 'In Progress',
  SUBMITTED = 'Submitted',
  SIGNED = 'Signed',
  PAID = 'Paid',
  LOCKED_IN = 'Locked In',
  REJECTED = 'Rejected',
  INVITED = 'Invited',
}

export {
  AGENT_APPLICATION_INITIAL_STATES,
  AGENT_WITH_LANDLORD_APPLICATION_INITIAL_STATES,
  RENTER_APPLICATION_INITIAL_STATES,
  AGENT_MY_APPLICATION_TABS_STATUS_MAP,
};
